import GalleryThumbnailPresentation from 'components/GalleryThumbnail/GalleryThumbnailPresentation'

export default {
  Presentation: GalleryThumbnailPresentation,
}
